import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyComponent } from './components/empty/empty.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    EmptyComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    EmptyComponent
  ]
})
export class EmptyModule { }
